import {
  getFormIdField,
  updateSectionsWithFormStructure,
} from '../../../utils';

const getSectionsByType = (subjectUsedClasses, assignees, callback) => {
  const regularSections = [];
  let progressSections = [];
  let disabledStudents = [];

  subjectUsedClasses.forEach((section) => {
    const assigneesById = assignees.filter((a) => a.sectionId === section.id);
    if (assigneesById.length > 0) {
      // Set sections in progress.
      progressSections = progressSections.concat(
        assigneesById.map((assignee) => {
          const sectionAssignedStudents = section.students.filter((s) =>
            assignee.studentIds.includes(s.id),
          );
          const isIndividualAssignment =
            sectionAssignedStudents.length < section.students.length;
          const subGroupStudents = isIndividualAssignment
            ? sectionAssignedStudents
            : [];

          return {
            ...section,
            students: sectionAssignedStudents,
            isIndividualAssignment,
            subGroupStudents,
          };
        }),
      );

      // Check for unassigned students.
      const sectionAssignedStudents = assigneesById.reduce(
        (acc, assignee) => acc.concat(assignee.studentIds),
        [],
      );
      const assigneeStudentsLength = sectionAssignedStudents.length;

      if (
        assigneeStudentsLength > 0 &&
        section.students.length > assigneeStudentsLength
      ) {
        regularSections.push(section);
        disabledStudents = disabledStudents.concat(
          section.students
            .filter((student) => sectionAssignedStudents.includes(student.id))
            .map((student) => ({
              ...student,
              id: getFormIdField(student.id, section.id),
              studentId: student.id,
              sectionId: section.id,
            })),
        );
      }
    } else {
      regularSections.push(section);
    }
  });

  const response = {
    regularSections: updateSectionsWithFormStructure(regularSections),
    progressSections: updateSectionsWithFormStructure(progressSections),
    disabledStudents,
  };

  if (!callback) {
    return response;
  }

  callback(response);
};

export default getSectionsByType;
